import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

const TYPE_ICONS = {health: '🏥', dental: '🦷', vision: '👁️', life: '🛡️', '401k': '💰', hsa: '🏦', fsa: '🏦'};

export default function Benefits() {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('/hcm/my-benefits').then(r => r.ok ? r.json() : []).then(setBenefits).finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout><div className="flex justify-center items-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div></div></Layout>;

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">My Benefits</h2>
      {benefits.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow"><p className="text-gray-500">No benefits enrolled.</p></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {benefits.map(b => (
            <div key={b.id} className="bg-white rounded-lg shadow p-5">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">{TYPE_ICONS[b.planType?.toLowerCase()] || '📋'}</span>
                <div>
                  <h3 className="font-semibold text-gray-900">{b.planName}</h3>
                  <p className="text-sm text-gray-500">{b.planType} · {b.provider || 'N/A'}</p>
                </div>
              </div>
              <div className="flex justify-between text-sm">
                <div><p className="text-gray-500">Your Cost</p><p className="font-medium text-gray-900">{b.costEmployee != null ? `$${Number(b.costEmployee).toLocaleString()}/mo` : '—'}</p></div>
                <div><p className="text-gray-500">Status</p><span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${b.status === 'active' ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'}`}>{b.status}</span></div>
                <div><p className="text-gray-500">Enrolled</p><p className="font-medium text-gray-900">{b.enrolledAt || '—'}</p></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
